"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingClickCircleStepSuccessEvent = exports.OnboardingClickCompleteApplicationSuccessEvent = exports.OnboardingValidationFailedEvent = exports.OnboardingClickNextStepSuccessEvent = exports.OnboardingClickNextStepEvent = exports.OnboardingClickAddAnotherSuccessEvent = exports.OnboardingUploadPhotoSuccessEvent = exports.OnboardingClickUploadPhotoSuccessEvent = exports.OnboardingWorkerAuthorizedSuccessEvent = exports.OnboardingTermLandingSuccessEvent = exports.OnboardingProfileInfoLandingSuccessEvent = exports.OnboardingReferenceLandingSuccessEvent = exports.OnboardingEducationLandingSuccessEvent = exports.OnboardingExperienceLandingSuccessEvent = exports.OnboardingLicenseLandingSuccessEvent = exports.OnboardingLandingSuccessEvent = void 0;
const base_event_1 = require("./base.event");
class OnboardingLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_LANDING_SUCCESS';
    }
}
exports.OnboardingLandingSuccessEvent = OnboardingLandingSuccessEvent;
class OnboardingLicenseLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_LICENSE_AND_CERTIFICATION_LANDING_SUCCESS';
    }
}
exports.OnboardingLicenseLandingSuccessEvent = OnboardingLicenseLandingSuccessEvent;
class OnboardingExperienceLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_WORK_EXPERIENCES_LANDING_SUCCESS';
    }
}
exports.OnboardingExperienceLandingSuccessEvent = OnboardingExperienceLandingSuccessEvent;
class OnboardingEducationLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_EDUCATION_LANDING_SUCCESS';
    }
}
exports.OnboardingEducationLandingSuccessEvent = OnboardingEducationLandingSuccessEvent;
class OnboardingReferenceLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_REFERENCES_LANDING_SUCCESS';
    }
}
exports.OnboardingReferenceLandingSuccessEvent = OnboardingReferenceLandingSuccessEvent;
class OnboardingProfileInfoLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_PERSONAL_INFO_LANDING_SUCCESS';
    }
}
exports.OnboardingProfileInfoLandingSuccessEvent = OnboardingProfileInfoLandingSuccessEvent;
class OnboardingTermLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_VERIFICATION_AND_TERMS_LANDING_SUCCESS';
    }
}
exports.OnboardingTermLandingSuccessEvent = OnboardingTermLandingSuccessEvent;
class OnboardingWorkerAuthorizedSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_WORK_AUTHORIZED_SUCCESS';
    }
}
exports.OnboardingWorkerAuthorizedSuccessEvent = OnboardingWorkerAuthorizedSuccessEvent;
class OnboardingClickUploadPhotoSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_CLICK_UPLOAD_PHOTO_SUCCESS';
    }
}
exports.OnboardingClickUploadPhotoSuccessEvent = OnboardingClickUploadPhotoSuccessEvent;
class OnboardingUploadPhotoSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_UPLOAD_PHOTO_SUCCESS';
    }
}
exports.OnboardingUploadPhotoSuccessEvent = OnboardingUploadPhotoSuccessEvent;
class OnboardingClickAddAnotherSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_CLICK_ADD_ANOTHER_SUCCESS';
    }
}
exports.OnboardingClickAddAnotherSuccessEvent = OnboardingClickAddAnotherSuccessEvent;
class OnboardingClickNextStepEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_CLICK_NEXT_STEP';
    }
}
exports.OnboardingClickNextStepEvent = OnboardingClickNextStepEvent;
class OnboardingClickNextStepSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_CLICK_NEXT_STEP_SUCCESS';
    }
}
exports.OnboardingClickNextStepSuccessEvent = OnboardingClickNextStepSuccessEvent;
class OnboardingValidationFailedEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_VALIDATION_FAILED';
    }
}
exports.OnboardingValidationFailedEvent = OnboardingValidationFailedEvent;
class OnboardingClickCompleteApplicationSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_CLICK_COMPLETE_APPLICATION_SUCCESS';
    }
}
exports.OnboardingClickCompleteApplicationSuccessEvent = OnboardingClickCompleteApplicationSuccessEvent;
class OnboardingClickCircleStepSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ONBOARDING_CLICK_CIRCLE_STEP_SUCCESS';
    }
}
exports.OnboardingClickCircleStepSuccessEvent = OnboardingClickCircleStepSuccessEvent;
//# sourceMappingURL=activation.events.js.map